import { theme } from '@theme';
import { Dispatch, FC, SetStateAction } from 'react';
import { PortfolioNote } from '../../../../types/Note';
import { Typography } from '../../../style/Typography';
import ConfirmationModal from '../confirmation-modal/ConfirmationModal';

type RetryNoteModalProps = {
  currentNote: PortfolioNote;
  dealerId: string;
  notesRetryModalOpen: boolean;
  retry: () => void;
  setNotesRetryModalOpen: Dispatch<SetStateAction<boolean>>;
  setSentRetries: Dispatch<SetStateAction<PortfolioNote[]>>;
};

const RetryNoteModal: FC<RetryNoteModalProps> = ({
  currentNote,
  dealerId,
  notesRetryModalOpen,
  retry,
  setNotesRetryModalOpen,
  setSentRetries,
}) => {
  const handleCancelNotesRetryModal = () => {
    setNotesRetryModalOpen(false);
  };

  const handleSubmitNotesRetryModal = () => {
    retry();
    setNotesRetryModalOpen(false);
  };

  return (
    <ConfirmationModal
      isOpen={notesRetryModalOpen}
      handleCancelClick={handleCancelNotesRetryModal}
      handleSubmitClick={handleSubmitNotesRetryModal}
      cancelButtonText='Cancel'
      submitButtonText='Ok'
      title='Retry Confirmation'
      overlayClassName='notes-modal-overlay confirmation'
      contentClassName='notes-modal-confirmation-content'
      padding='20px 50px 20px 20px'
      minHeight='206px'
      showCloseIcon={true}
      bodyComponent={
        <Typography size={theme.typography.h4}>
          If the error experienced on this note is also the same for others, we will retry all
          related errors.
        </Typography>
      }
    />
  );
};

export default RetryNoteModal;
